Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-assembly-cost', function (envelope) {
        var $context = envelope.message.data.context,
            $control = $('.x-product-details-assembly-cost', $context);

        if ($control.length < 1) return;

        var control = $control.get(0);
        var model = null;
        var formData = {
            skuId: 0,
            postalCode: '',
            countryCode: LhApp.Context.Country || 'GR',
        }

        control.loading = function (loading) {
            if (loading) {
                $control.addClass('x-loading');
            } else {
                $control.removeClass('x-loading');
            }
        };

        control.update = function() {
            if (model && model.SupportsAssembly) {
                $('.js-assembly-cost', $control).text(model.AssemblyCost);
                $('.assembly-supported', $control).removeClass('hidden');  
            } else {
                $('.assembly-not-supported', $control).removeClass('hidden');  
            }

            $('.results-container', $control).removeClass('hidden');    
        };

        control.submit = function () {
            control.loading(true);

            var currentProductState = Vendd.Product.Controller.getState();
            var skuId = currentProductState.selectedId;
            formData.skuId = skuId;

            formData.postalCode = $('input[name=postalCode]', $control).val();

            Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.GetProductAssemblyCost(formData.skuId, formData.postalCode, formData.countryCode));
        }
       
        $control.on('click', '.js-submit', function () {
            if (acf.validate())
                control.submit();
        });

        $control.on('keyup', 'input[name="postalCode"]', function () {
            removeWhiteSpaces($(this));
            control.setField($(this));
        });

        control.setField = function (field) {
            var fieldName = field.attr('name');
            acf.validate(fieldName);
        };

        //init validation engine
        var validationOptions = {};

        //add email validation
        if ($('input[name="postalCode"]', $control).length > 0) {
            validationOptions.postalCode = { required: 'postalCode-required' };
            if (formData.countryCode === 'GR') {
                validationOptions.postalCode = { ...validationOptions.postalCode, ...{ isGreekPostalCode: 'postalCode-invalid' } };
            }   
        }

        $control.validationEngine(validationOptions);
        var acf = $control.data('validationEngine');
        
        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetProductAssemblyCostSuccess, control, function (envelope) {
            model = envelope.message.data.model;
            model = JSON.parse(model);

            control.update();
            control.loading(false);
        });

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetProductAssemblyCostFailed, control, function () {
            control.loading(false);
        });
        
    });
});